import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import { constrainedWidth } from "@unauthenticated/shared/components/SignInBlock/SignInBlock.styles";

export const columnsContainer = css`
  height: 100%;
  margin: 0;
`;

export const leftColumn = (theme: Theme) => css`
  background: ${theme.primary.backgroundBox};
  border-right: 1px solid ${theme.system.borderBase};
  padding: 16px 112px;
  text-align: center;

  @media (min-width: ${dimensions.tablet}) and (max-width: ${dimensions.tabletMax}) {
    padding: 16px;
  }

  @media (min-width: ${dimensions.desktop}) and (max-width: ${dimensions.desktopMax}) {
    padding-inline: 80px;
  }
`;

export const storefrontLeftColumnBlock = (theme: Theme) => css`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: ${theme.ds5.gap[800]};
`;

export const rightColumn = css`
  padding: 1rem;
  margin: auto;
`;

export const layoutContainer = css`
  flex: 1 0 auto;
`;

export const fullBleedContent = css`
  ${constrainedWidth};
  width: 100%;
`;
